import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a4fe55e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"text-align":"center"} }

import { useSolidSession } from "@datev-research/mandat-shared-composables";

export default /*#__PURE__*/_defineComponent({
  __name: 'UnauthenticatedCard',
  setup(__props) {

const { session } = useSolidSession();
const redirect_uri = window.location.href;

function redirectToLogin() {
  const idp = "https://solid.dev.datev.de";
  session.login(idp, redirect_uri);
}

return (_ctx: any,_cache: any) => {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    class: "mt-6",
    style: {"width":"50%","margin-top":"2rem","display":"block","margin-left":"auto","margin-right":"auto"}
  }, {
    content: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, [
        _createTextVNode(" 401 Unauthenticated : Click "),
        _createElementVNode("span", {
          class: "redirect",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (redirectToLogin()))
        }, "here"),
        _createTextVNode(" to login or use the button in the top-right corner! ")
      ])
    ]),
    _: 1
  }))
}
}

})